export const riskFlagOptions = [
    {
        group: 'Clinical Risks',
        color: '#d32f2f', // red
        options: [
            'Oxygen Required',
            'Infection Risk / Isolation',
            'Covid-19',
            'Influenza',
            'MRSA',
            'C.Diff',
            'Allergy Alert',
            'Diabetic (Insulin Dependent)',
            'Epilepsy / Seizure Risk',
            'Cardiac Condition',
            'PEG / Feeding Tube',
            'Catheter / Stoma',
            'Tracheostomy',
            'Open Wounds / Dressings',
            'DNACPR (Do Not Attempt Resuscitation)',
            'End of Life Care',
        ],
    },
    {
        group: 'Cognitive / Behavioural',
        color: '#1976d2', // blue
        options: [
            'Dementia / Confusion',
            'Learning Disability',
            'Autism Spectrum Disorder',
            'Mental Health Concern',
            'Aggression / Behavioural Risk',
            'Non-Verbal / Communication Difficulty',
        ],
    },
    {
        group: 'Mobility / Transfer',
        color: '#2e7d32', // green
        options: [
            'Requires Hoist / Slide Sheet',
            'Requires Assistance of 2+ Staff',
            'Bariatric Patient',
            'Falls Risk',
            'Balance Issues',
        ],
    },
    {
        group: 'Safeguarding / Operational',
        color: '#ed6c02', // amber
        options: [
            'Escort Required',
            'Safeguarding Concern',
            'Requires Interpreter',
            'Confidential Location (High Risk / Domestic Violence)',
            'Requires Nurse / Paramedic Escort',
        ],
    },
]